<template>

  <div class="uk-card uk-card-default uk-card-primary uk-card-hover">


    <div class="uk-card-header">
      <div class="uk-card-title">Ranking</div>
    </div>

    <div class="uk-card-body">

      <div class="card-stretch-container">
        <div class = 'rank-group'>
        <div class="bignumber secondary">
          <div class='number'>
            {{driverStationRank}}
          </div>
          <div class='label'>
            Station Rank
          </div>
        </div>
        <div class="changenumber">
          {{driverStationRankChange > 0 ? "+" : "-"}}{{driverStationRankChange}}
        </div>
      </div>
        <div class = 'rank-group'>
        <div class="bignumber">
          <div class='number'>
            {{driverTerritoryRank}}
          </div>
          <div class='label'>
            Territory Rank
          </div>
        </div>
        <div class="changenumber">
          {{driverStationRankChange > 0 ? "+" : "-"}}{{driverTerritoryRankChange}}
        </div>
          </div>
      </div>
    </div>
  </div>


</template>

<script>
	export default {
		name: "ComplianceCard",
    props: ["driverStationRank", "driverStationRankChange", "driverTerritoryRank", "driverTerritoryRankChange"],
		computed: {
			complianceRate: function () {
				return Math.round((this.driverCompliedCount / this.volume) * 100)
			}
		}
	}
</script>

<style lang="less" scoped>


  @import "../../assets/less/palette.less";
  @import "../../assets/less/theme.less";



  .card-stretch-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }


  .rank-group {
    width: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
  }



  .bignumber {

    color: white!important;

    .number {
      font-size: 60px;
    }

    .label {
      font-size: 12px;
    }
  }

  .changenumber {
    margin-left: .5em;
    font-size: 18px;
  }


  @media only screen and (max-width: @breakpoint-medium) {
      .card-stretch-container {
        flex-direction: column;
        justify-content: center;

        .bignumber {
           margin: 10px 0;
        }
      }
  }

</style>
